import React from 'react'
import { Box, Typography } from '@mui/material'

interface StageSectionProps {
  /** Omit when the page header already names what the step shows. */
  title?: string
  description?: React.ReactNode
  /** Drawn in place of the title and description, e.g. Results' info box. */
  summary?: React.ReactNode
  /** The stage's actions, right-aligned beside the title on wide screens. */
  actions?: React.ReactNode
  children: React.ReactNode
}

// The one layout every Theme AI stage shares: a title that says what this step
// is for, one line of why, the step's actions, then its content.
const StageSection: React.FC<StageSectionProps> = ({ title, description, summary, actions, children }) => (
  <Box sx={{ px: 3, py: 3, display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 1280 }}>
    <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
      <Box sx={{ minWidth: 0 }}>
        {summary}
        {title && <Typography variant="h6">{title}</Typography>}
        {description && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: title ? 0.5 : 0, maxWidth: '70ch' }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>{actions}</Box>}
    </Box>
    {children}
  </Box>
)

export default StageSection
